import { EventManager, Events } from "@events";
import { ModuleManager, SectionList } from "@module-system";
import WebRTCRoom from "./webrtcRoom";
import locales from "./locales";
import ConnectionTimeoutPopup from "./components/ConnectionTimeoutPopup.vue";
import DisconnectPopup from "./components/DisconnectPopup.vue";
import RecordingRecoveryOverlay from "./components/RecordingRecoveryOverlay.vue";
import RemoteVideoMuteButtonVue from "./components/RemoteVideoMuteButton.vue";
import RemoteAudioMuteButtonVue from "./components/RemoteAudioMuteButton.vue";
import CommonConditions from "@lib/commonConditions";
import TurnTest from "./pages/TurnTest.vue";
import RecordingFailedMessage from "./components/RecordingFailedMessage.vue";
import configurationProvider from "@/Core/configurationProvider";

const rootEventEmitter = EventManager.rootEventEmitter();

/**
 * @type {import('@module-system').IModule}
 */
const module = {
  name: "PureWebRTC",
  version: "1.0.0",
  rooms: [],
  async register() {
    ModuleManager.addLocales(locales, "PureWebRTC");

    ModuleManager.addViewModule({
      key: "webrtc-connection-timeout",
      ViewComponent: ConnectionTimeoutPopup,
      section: SectionList.CallModal,
    });

    ModuleManager.addViewModule({
      key: "webrtc-disconnect-timeout",
      ViewComponent: DisconnectPopup,
      section: SectionList.CallModal,
    });

    ModuleManager.addViewModule({
      key: "recording-recovery-overlay",
      ViewComponent: RecordingRecoveryOverlay,
      section: SectionList.CallModal,
    });

    ModuleManager.addViewModule({
      key: "recording-error",
      ViewComponent: RecordingFailedMessage,
      section: SectionList.CallTopPanel,
      size: 100,
    });

    const remoteAudioMuteButton = window.CONFIG?.CALL_BUTTONS?.REMOTE_AUDIO_MUTE ?? {};
    remoteAudioMuteButton.ENABLED = remoteAudioMuteButton.ENABLED ?? true;
    remoteAudioMuteButton.ORDER = remoteAudioMuteButton.ORDER ?? 11;

    const remoteVideoMuteButton = window.CONFIG?.CALL_BUTTONS?.REMOTE_VIDEO_MUTE ?? {};
    remoteVideoMuteButton.ENABLED = remoteVideoMuteButton.ENABLED ?? true;
    remoteVideoMuteButton.ORDER = remoteVideoMuteButton.ORDER ?? 12;

    ModuleManager.addViewModule({
      key: "remote-video-mute-button",
      order: remoteVideoMuteButton.ORDER,
      section: SectionList.CallButtonsList,
      ViewComponent: RemoteVideoMuteButtonVue,
      Condition: (rtcId) => CommonConditions.isAgent(rtcId) && remoteVideoMuteButton.ENABLED,
      stackable: false,
    });

    ModuleManager.addViewModule({
      key: "remote-audio-mute-button",
      order: remoteAudioMuteButton.ORDER,
      section: SectionList.CallButtonsList,
      ViewComponent: RemoteAudioMuteButtonVue,
      Condition: (rtcId) => CommonConditions.isAgent(rtcId) && remoteAudioMuteButton.ENABLED,
      stackable: false,
    });

    const turnTestActive = configurationProvider.getBoolRef("TURN_TEST_ACTIVE", true);

    if (turnTestActive.value) {
      ModuleManager.addRoute({
        path: "/test/turn",
        name: "Turn Test Page /test/turn",
        component: TurnTest,
        beforeEnter: (to, from, next) => {
          if (!turnTestActive.value) {
            next(false);
            return;
          }
          next();
        },
      });

      ModuleManager.addRoute({
        path: "/t/turn",
        name: "Turn Test Page /t/turn",
        component: TurnTest,
        beforeEnter: (to, from, next) => {
          if (!turnTestActive.value) {
            next(false);
            return;
          }
          next();
        },
      });
    }

    rootEventEmitter.on(Events.VideoCallCreated, (e) => {
      if (e.ignoreWebRtcRoom) {
        return;
      }
      const room = new WebRTCRoom(e.rtcId);
      this.rooms.push(room);
    });

    ModuleManager.addRoute({
      path: "/status-check",
      name: "Status Check Page",
      component: () => import("./pages/StatusCheck.vue"),
    });
  },
};
export default module;
